// app
export const SET_APP_VERSION = 'SET_APP_VERSION'
// locale
export const SET_LOCALE = 'SET_LOCALE'
// error
export const SHOW_ERROR = 'SHOW_ERROR'
export const ERROR = 'ERROR'
// success
export const SHOW_SUCCESS = 'SHOW_SUCCESS'
export const SUCCESS = 'SUCCESS'
// loading
export const SHOW_LOADING = 'SHOW_LOADING'
export const SHOW_TOP_LOADING = 'SHOW_TOP_LOADING'
// auth
export const IS_LOGGED_IN = 'IS_LOGGED_IN'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const SAVE_USER = 'SAVE_USER'
export const LOGOUT = 'LOGOUT'
export const EMAIL_VERIFIED = 'EMAIL_VERIFIED'
export const RESET_EMAIL_SENT = 'RESET_EMAIL_SENT'
export const SHOW_CHANGE_PASSWORD_INPUTS = 'SHOW_CHANGE_PASSWORD_INPUTS'
// profile
export const FILL_PROFILE = 'FILL_PROFILE'
export const ADD_PROFILE_DATA = 'ADD_PROFILE_DATA'
// Ads
export const FILL_ALL_ADS = 'FILL_ALL_ADS'
// Admin - Ads
export const ADS = 'ADS'
export const TOTAL_ADS = 'TOTAL_ADS'
export const UPLOAD_PERCENT = 'UPLOAD_PERCENT'
// Admin - Users
export const USERS = 'USERS'
export const TOTAL_USERS = 'TOTAL_USERS'
// Admin - Hotspots
export const HOTSPOTS = 'HOTSPOTS'
export const TOTAL_HOTSPOTS = 'TOTAL_HOTSPOTS'
export const SELECTED_HOTSPOT = 'SELECTED_HOTSPOT'
// Admin - Dash
export const ONLINE_USERS = 'ONLINE_USERS'
export const TOTAL_ONLINE_USERS = 'TOTAL_ONLINE_USERS'
export const MULTI_AXIS_CHART = 'MULTI_AXIS_CHART'
export const DONUT_CHART = 'DONUT_CHART'
export const TOTAL_PAGE_VIEWS = 'TOTAL_PAGE_VIEWS'
export const LAST_CONNECTIONS = 'LAST_CONNECTIONS'
// Admin - Clients
export const CLIENT = 'CLIENT'
// admin - Connections
export const CONNECTIONS = 'CONNECTIONS'
export const TOTAL_CONNECTIONS = 'TOTAL_CONNECTIONS'
// admin - Emails
export const MAILS = 'MAILS'
export const TOTAL_MAILS = 'TOTAL_MAILS'
// admin - Social
export const TRIPDATA = 'TRIPDATA'
export const GOOGLEDATA = 'GOOGLEDATA'
// admin - AccessControl
export const VIPS = 'VIPS'
export const TOTAL_VIPS = 'TOTAL_VIPS'
export const BLOCKEDS = 'BLOCKEDS'
export const TOTAL_BLOCKEDS = 'TOTAL_BLOCKEDS'
